<script>
import { menu_url } from "@/api/url";

import styles from "./mainMenu.module.scss";

import { animate } from "../common/js/animate";

import User from "./components/user.vue";

import { mapMutations, mapActions, mapState, mapGetters } from "vuex";
import systemConfig from '@/utils/globalVal.js'

export default {
  name: "main-menu",
  data() {
    return {
      sidearr: [],
    };
  },

  methods: {
    ...mapActions("menu", [
      "setSubmenuList",
      "setMainMenuMovePlace",
      "setCurrentMovePlace",
      "setCurrentSubMenu",
    ]),
    getMenu() {
      this.$get(menu_url(), {}).then((data) => {
        this.sidearr = data[0]?.children ?? [];
        const dataOne = [this.sidearr[0]];
        // 保存菜单数据到 store
        this.$store.dispatch('menu/setMenuData', [{ children: this.sidearr }]);
      });
    },
    onMenuClick(e, index, item) {
      const currentIndex = e.target.getAttribute("data-index");
      const distance = currentIndex * 118;
      this.setMainMenuMovePlace({ place: distance });
      const moveDom = document.querySelector(".move");
      animate(moveDom, distance, "left");
      this.getChildrenList(currentIndex);
      this.setCurrentMovePlace({ place: 0 });
      // 新增逻辑：切换大菜单时自动高亮第一个一级菜单的第一个二级菜单
      const firstSubMenu = this.sidearr[currentIndex]?.children?.[0];
      const firstSecondMenu = firstSubMenu?.children?.[0];
      if (firstSubMenu && firstSecondMenu) {
        // 设置左侧一级菜单展开
        let list = this.sidearr[currentIndex]?.children?.map((item, idx) => ({
          ...item,
          show: idx === 0
        })) || [];
        // 设置第一个二级菜单current
        list = list.map((item, idx) => {
          if (idx === 0 && Array.isArray(item.children)) {
            item.children = item.children.map((c, i) => ({
              ...c,
              current: i === 0
            }));
          }
          return item;
        });
        this.setSubmenuList(list);
        this.setCurrentSubMenu(firstSecondMenu);
        this.$router.push(firstSecondMenu.href);
      } else {
        // fallback: 跳转到主菜单第一个页面
        const currentHref = this.defaultHref(
          this.sidearr[currentIndex]?.children ?? []
        );
        if (currentHref) {
          this.$router.push(currentHref);
        } else {
          this.$router.push("/main/home");
        }
      }
    },
    defaultHref(c) {
      let currentHref = "";
      (function deep(c) {
        for (let i = 0; i < c.length; i++) {
          if (c[0].children.length === 0) {
            currentHref = c[0].href;
          } else {
            const cc = c[0].children;
            deep(cc);
          }
        }
      })(c);
      return currentHref;
    },
    onMenuOver(e) {
      const el = e.target;
      el.classList.add(styles.active);
    },
    onMenuOut(e) {
      const el = e.target;
      el.classList.remove(styles.active);
    },
    getChildrenList(index) {
      let list = [];
      const tempList = this.sidearr[index]?.children ?? [];
      list = tempList.map((item, i) => {
        return this.setupCurrentMenu(item, i);
      });
      this.setSubmenuList(list);
    },
    setupCurrentMenu(c, index) {
      const len = c.children.length;
      const _this = this;
      c.show = false;
      if (len > 0) {
        if (index === 0) {
          c.show = true;
        }
        c.current = false;
        const tempList = c.children;
        const tempChildren = tempList.map((item, i) => {
          if (index === 0 && i === 0) {
            item.current = true;
          } else {
            item.current = false;
          }
          return item;
        });
        c.children = tempChildren;
        // 点击主菜单，如果子菜单下有已选中的菜单，二级菜单展开，暂未实现
        // const current=tempChildren.findIndex(item=>this.currentSubMenu.id===item.id);
        // if(current!=-1){
        //   c.show=true;
        // }
      } else {
        if (index === 0) {
          c.current = true;
        } else {
          c.current = false;
        }
      }
      return c;
    },
    initMovePlace() {
      let distance = 0;
      if (!this.mainMenuMovePlace) {
        distance = 0;
      } else {
        distance = this.mainMenuMovePlace.place;
      }
      console.log('distance=>',distance)
      const moveDom = document.querySelector(".move");
      animate(moveDom, distance, "left");
    },
  },
  components: {
    User,
  },
  render() {
 
    const { sidearr, actived } = this;
    const { onMenuOver, onMenuClick, onMenuOut } = this;
    if(this.isFullscreen){
      return null
    }else{
         return (
      <div class={styles["main-menu"]}>
        <div class={styles.logo}>
          <img src={require("@/assets/images/menu_img/logo.png")} />
          <span>{systemConfig.LOGO_NAME}</span>
        </div>
        <div class={styles.menus}>
          <span class={[styles.move, "move"].join(" ")}></span>
          {sidearr.map((item, index) => (
            <span
              data-index={index}
              onMouseover={onMenuOver}
              onMouseout={onMenuOut}
              onClick={(e) => onMenuClick(e, index, item)}
            >
              {item.title}
            </span>
          ))}
        </div>
        <div class={styles.user}>
          <User />
        </div>
      </div>
    );
    }
 
  },
  created(){
    
  },
  mounted() {
    this.getMenu();
    this.initMovePlace();
  },
  computed: {
    ...mapState({
      // list: state => state.menu.subMenuList,
      currentSubMenu: (state) => state.menu.currentSubMenu,
      currentMovePlace: (state) => state.menu.currentMovePlace,
      mainMenuMovePlace: (state) => state.menu.mainMenuMovePlace,
      isFullscreen:(state)=> state.fullscreen.isFullscreen
    }),
  },
};
</script>



